import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useAuthStatus from './useAuthStatus';

// useRedirectFromAuth hook redirects the user from any authentication page, e.g. UserLogin, ResetPassword..etc
// to the main page '/' if the user is actually logged-in
// (you can wrap any authentication page with AuthPageLayout.component.tsx, it already utilises this hooks)
const useRedirectFromAuth = (): void => {
  const { isAuthenticated } = useAuthStatus();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);
};

export default useRedirectFromAuth;
